import { createSvgIcon } from '@material-ui/core/utils';

export const Stop = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5"
    viewBox="0 0 24 24"
  >
    <path fill="#9CA9B3" d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M9,9H15V15H9" />
  </svg>,
  'Stop'
);
